module.exports = __webpack_public_path__ + "img/wzf_14.bd90a454.png";